export const GET_JOBS = 'GET_JOBS';
export const GET_JOB = 'GET_JOB';
export const GET_GEOCODES = 'GET_GEOCODES';
export const GEOCODE_ERROR = 'GEOCODE_ERROR';
export const SEARCH_JOBS = 'SEARCH_JOBS';
export const FETCH_ERROR = 'FETCH_ERROR';